import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'toPersianChars',
})
export class ToPersianCharsPipe implements PipeTransform {

  public static toPersianChars(str: string): string | undefined {
    if (!str) {
      return str;
    }

    return str
      .replace(/ي/g, 'ی')
      .replace(/ك/g, 'ک')
      .replace(/٫/g, '٫')
      .replace(/٬/g, '٬')
      .replace(/٭/g, '٭')
      .replace(/٪/g, '٪')
      .replace(/ـ/g, 'ـ')
      .replace(/ً/g, 'ً')
      .replace(/ٌ/g, 'ٌ')
      .replace(/ٍ/g, 'ٍ')
      .replace(/َ/g, 'َ')
      .replace(/ُ/g, 'ُ')
      .replace(/ِ/g, 'ِ')
      .replace(/ّ/g, 'ّ')
      .replace(/ْ/g, 'ْ')
      .replace(/ٰ/g, 'ٰ')
      .replace(/ٔ/g, 'ٔ')
      .replace(/ٕ/g, 'ٕ')
      .replace(/ٖ/g, 'ٖ')
      .replace(/ٗ/g, 'ٗ')
      .replace(/٘/g, '٘')
      .replace(/ٙ/g, 'ٙ')
      .replace(/ٚ/g, 'ٚ')
      .replace(/ٛ/g, 'ٛ');
  }

  transform(value: any): any {
    if (typeof value === 'string') {
      return ToPersianCharsPipe.toPersianChars(value);
    }
    return value;
  }
}
